import { ReactNode, createContext } from "react";
import {
  useScopeContext,
  UseScopeContext,
  UseScopeParams,
} from "~/hooks/useScope";

export const ScopeContext = createContext<UseScopeContext | undefined>(
  undefined,
);

export interface ScopeProviderProps {
  children: ReactNode;
  params?: UseScopeParams;
}

export function ScopeProvider({ children, params }: ScopeProviderProps) {
  const context = useScopeContext(params);
  return (
    <ScopeContext.Provider value={context}>{children}</ScopeContext.Provider>
  );
}
